/** 認証チェックを行わない(未認証でも到達できる)パス。 */
export const authFreePaths = [
  '/login',
  '/sso-login',
  '/multi-factor-authentication',
  '/forgot-password',
  '/new-password',
  '/new-password-required',
  '/terms-of-use',
  '/privacy-policy',
  '/playback'
]
